"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var utils_1 = require("./utils");
function estimateMaxSpendable(_a) {
    var account = _a.account, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    parentAccount = _a.parentAccount, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    transaction = _a.transaction;
    var balance = account.balance;
    // as fees are based on a currency conversion, we stay
    // on the safe side here and double the estimate for "max spendable"
    var estimatedFee = utils_1.estimatedFees.multipliedBy(utils_1.estimatedFeeSafetyRate);
    var maxSpendable = balance.minus(estimatedFee);
    // set max spendable to 0 if negative
    // for cases where the user's account balance is smaller than the estimated fee
    if (maxSpendable.isLessThan(0)) {
        maxSpendable = new bignumber_js_1["default"](0);
    }
    return Promise.resolve(maxSpendable);
}
exports["default"] = estimateMaxSpendable;
//# sourceMappingURL=js-estimateMaxSpendable.js.map